import React from "react";
import { Link, useLocation } from "react-router-dom";

/**
 * Footer — quiet anchor with Privacy + Terms (required for store listings).
 * Hidden inside the Oracle (immersive) and Messages (chat) views to keep
 * those rooms uncluttered. Always visible on Landing, Traditions, Weekly,
 * Settings, and PublicProfile so a visitor can always find the legal pages.
 */
const HIDDEN_PREFIXES = ["/oracle", "/messages", "/login"];

export default function Footer() {
  const { pathname } = useLocation();
  if (HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"))) {
    return null;
  }
  return (
    <footer
      data-testid="site-footer"
      className="mt-24 px-6 sm:px-10 py-10 hairline-t bg-background"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <span className="serif italic text-sm text-muted-foreground">
          Cor·relate — the same truth, in every tongue.
        </span>
        <nav aria-label="Footer" className="flex items-center gap-6">
          <Link
            to="/privacy"
            data-testid="footer-privacy"
            className="mono text-[10px] uppercase tracking-[0.22em] text-muted-foreground hover:text-foreground transition-colors"
          >
            Privacy
          </Link>
          <Link
            to="/terms"
            data-testid="footer-terms"
            className="mono text-[10px] uppercase tracking-[0.22em] text-muted-foreground hover:text-foreground transition-colors"
          >
            Terms
          </Link>
          <Link
            to="/press"
            data-testid="footer-press"
            className="mono text-[10px] uppercase tracking-[0.22em] text-muted-foreground hover:text-foreground transition-colors"
          >
            Press
          </Link>
          <Link
            to="/methodology"
            data-testid="footer-methodology"
            className="mono text-[10px] uppercase tracking-[0.22em] text-muted-foreground hover:text-foreground transition-colors"
          >
            Methodology
          </Link>
          <a
            href="mailto:privacy@correlate.online"
            data-testid="footer-contact"
            className="mono text-[10px] uppercase tracking-[0.22em] text-muted-foreground hover:text-foreground transition-colors"
          >
            Contact
          </a>
        </nav>
      </div>
    </footer>
  );
}
